
import { createApp } from 'vue';
import App from './App.vue';
import './assets/tailwind.css';
import './assets/css/globals.css';
import { MotionPlugin } from '@vueuse/motion';
import { createHead } from '@vueuse/head';
import router from '.././src/routes.js';
const app = createApp(App);
app.use(router);
const head = createHead();
app.use(head);
app.use(MotionPlugin);
app.mount('#app');

